import { Facebook, Instagram, Youtube } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets-m6fa6gv7.emergentagent.net/job_amtm-animal-care/artifacts/8pyhgooh_AMTM-Logo-03.webp";

export default function PublicFooter() {
  return (
    <footer className="bg-amtm-text text-amtm-bg mt-20" data-testid="public-footer">
      <div className="max-w-6xl mx-auto px-6 md:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <img src={LOGO_URL} alt="AMTM" className="h-16 w-auto object-contain mb-4" />
          <p className="text-sm text-amtm-bg/70 leading-relaxed">
            Animal Matter To Me (AMTM) rescues, treats, and rehabilitates injured street dogs and cats across Mumbai and parts of Maharashtra.
          </p>
        </div>
        <div>
          <h4 className="font-display text-lg mb-3">Visit AMTM</h4>
          <a
            href="https://amtmindia.org"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-amtmindia-link"
            className="text-sm text-amtm-tealLight hover:underline"
          >
            amtmindia.org →
          </a>
          <p className="text-sm text-amtm-bg/70 mt-2">Malad West, Mumbai, Maharashtra, India</p>
          <p className="text-sm text-amtm-bg/70 mt-2">
            <a href="tel:+919920737737" data-testid="footer-phone" className="hover:text-amtm-tealLight">+91 9920 737 737</a>
          </p>
          <p className="text-sm text-amtm-bg/70">
            <a href="mailto:getinvolved@amtmindia.org" data-testid="footer-email" className="hover:text-amtm-tealLight">getinvolved@amtmindia.org</a>
          </p>
        </div>
        <div>
          <h4 className="font-display text-lg mb-3">Legal</h4>
          <ul className="space-y-2 text-sm text-amtm-bg/70">
            <li><Link to="/terms" data-testid="footer-terms-link" className="hover:text-amtm-tealLight">Terms &amp; Conditions</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-amtm-tealLight">Privacy Policy</Link></li>
            <li><Link to="/refund-policy" data-testid="footer-refund-policy-link" className="hover:text-amtm-tealLight">Refund &amp; Cancellation</Link></li>
            <li><Link to="/contact" data-testid="footer-contact-link" className="hover:text-amtm-tealLight">Contact Us</Link></li>
            <li><Link to="/transparency" data-testid="footer-transparency-link" className="hover:text-amtm-tealLight">Transparency</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display text-lg mb-3">Follow Us</h4>
          <div className="flex gap-3">
            <a href="https://www.facebook.com/amtmindia" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="p-2 rounded-full bg-amtm-bg/10 hover:bg-amtm-teal/80 transition-colors">
              <Facebook className="h-4 w-4" />
            </a>
            <a href="https://www.instagram.com/amtmindia/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="p-2 rounded-full bg-amtm-bg/10 hover:bg-amtm-teal/80 transition-colors">
              <Instagram className="h-4 w-4" />
            </a>
            <a href="https://www.youtube.com/channel/UCz64RiyW03lib1S1OwCwPEQ" target="_blank" rel="noopener noreferrer" data-testid="footer-youtube" className="p-2 rounded-full bg-amtm-bg/10 hover:bg-amtm-teal/80 transition-colors">
              <Youtube className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-amtm-bg/10 py-4 text-center text-xs text-amtm-bg/50 space-y-1">
        <p>
          <Link to="/transparency" className="hover:text-amtm-tealLight" data-testid="footer-registration-link">
            Registered NGO &middot; 12AB &middot; 80G &middot; FCRA
          </Link>
        </p>
        <p>
          © {new Date().getFullYear()} Animal Matter To Me. Built with care by{" "}
          <a
            href="https://www.reflectionscreativemedia.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-credit-link"
            className="text-amtm-tealLight hover:underline"
          >
            Reflections Creative Media
          </a>
          .
        </p>
      </div>
    </footer>
  );
}
